import { createI18n } from "vue-i18n";
import en from "../lang/en.json";
import ar from "../lang/ar.json";

// Detect the user's language
const locale = document.querySelector('meta[name="locale"]').getAttribute('content') || document.body.getAttribute('data-locale') || 'en';

const messages = { en, ar };

const i18n = createI18n({
    legacy: false,
    locale: locale,
    fallbackLocale: "en",
    messages,
});

export default i18n;
